import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show header on auth pages
  const authPages = ['/login', '/register', '/2fa', '/forgot-password', '/reset-password'];
  if (authPages.includes(location.pathname)) return <>{children}</>;
  if (!user) return <>{children}</>;

  const isCustomer = user.role === 'customer';

  const customer = (() => {
    try { return JSON.parse(localStorage.getItem('selected_customer')); } catch { return null; }
  })();

  const handleLogout = async () => {
    localStorage.removeItem('selected_customer');
    await logout();
    navigate('/login');
  };

  const navBtn = (label, path) => (
    <button
      onClick={() => navigate(path)}
      style={{
        background: location.pathname.startsWith(path) ? 'rgba(255,255,255,0.2)' : 'none',
        border: 'none', color: 'white', padding: '6px 12px', borderRadius: '6px',
        cursor: 'pointer', fontSize: '13px', fontWeight: '500'
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>

      {/* ── Top header ── */}
      <header style={{ background: '#1A2A3A', color: 'white', padding: '0 24px', height: '52px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.2)', position: 'sticky', top: 0, zIndex: 100 }}>

        {/* Left — logo + customer */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div
            onClick={() => navigate(isCustomer ? '/calculator' : '/dashboard')}
            style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
          >
            <img
              src="/fcc-logo-mark-yellow.png"
              alt="FCC"
              style={{ height: '36px', width: 'auto', display: 'block' }}
            />
            <span style={{ fontWeight: '700', fontSize: '16px', letterSpacing: '0.02em' }}>
              FCC Billing
            </span>
          </div>
          {!isCustomer && customer && (
            <>
              <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '16px' }}>|</span>
              <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)' }}>
                {customer.name}
              </span>
              <button
                onClick={() => { localStorage.removeItem('selected_customer'); navigate('/select-customer'); }}
                style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: 'rgba(255,255,255,0.7)', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '11px' }}
              >
                Change
              </button>
            </>
          )}
          {isCustomer && user.customer_name && (
            <>
              <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '16px' }}>|</span>
              <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)' }}>{user.customer_name}</span>
            </>
          )}
        </div>

        {/* Center — nav links */}
        <nav style={{ display: 'flex', gap: '4px' }}>
          {isCustomer ? (
            <>
              {navBtn('Calculator', '/calculator')}
              {navBtn('Pro Search', '/pro-search')}
            </>
          ) : (
            <>
              {navBtn('Dashboard', '/dashboard')}
              {navBtn('New Invoice', '/invoices/new')}
              {navBtn('Invoices', '/invoices')}
              {navBtn('Quotes', '/quotes')}
              {navBtn('Pro Search', '/pro-search')}
              {(user?.role === 'boss' || user?.role === 'admin') && customer && (
                <>
                  {navBtn('Zone Rates', `/admin/zone-rates/${customer.customer_id}`)}
                  {navBtn('ZIP Data', `/admin/zip-data/${customer.customer_id}`)}
                  {navBtn('Settings', `/admin/settings/${customer.customer_id}`)}
                </>
              )}
              {user?.role === 'admin' && (
                <>
                  {navBtn('Customers', '/admin/customers')}
                  {navBtn('Users', '/admin/users')}
                </>
              )}
            </>
          )}
        </nav>

        {/* Right — user info + logout */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>
            {user?.email}
            <span style={{ marginLeft: '6px', background: 'rgba(255,255,255,0.15)', padding: '2px 6px', borderRadius: '4px', fontSize: '11px' }}>
              {user?.role}
            </span>
          </span>
          <button
            onClick={handleLogout}
            style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: 'white', borderRadius: '6px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px' }}
          >
            Sign out
          </button>
        </div>
      </header>

      {/* ── Page content ── */}
      <main style={{ flex: 1 }}>
        {children}
      </main>

      {/* ── Footer ── */}
      <footer style={{ background: '#1A2A3A', color: 'rgba(255,255,255,0.6)', padding: '12px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px' }}>
        <span>Florida Cargo Carrier · 5411 Johns Rd. Suite 607, Tampa, Florida 33634</span>
        <span>FCC Billing System · {new Date().getFullYear()}</span>
      </footer>
    </div>
  );
};

export default Layout;
